import { Typography, Box, SvgIcon } from "@mui/material";
import { ArrowCircleLeftRounded as ArrowCircleLeftRoundedIcon } from "@mui/icons-material";
import { useNavigate } from "./hooks";

const TitleHeadSess = ({ title, iconTitle, id, urlRedirect, name }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      <Box
        onClick={() => navigate(urlRedirect ? urlRedirect : "/")}
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <SvgIcon
          sx={{
            color: "secondaryGreen.main",
            fontSize: 30,
            display: { xs: "block", sm: iconTitle ? "block" : "none" },
            mr: 1,
          }}
        >
          <ArrowCircleLeftRoundedIcon />
        </SvgIcon>

        {iconTitle && (
          <Typography
            sx={{
              color: "secondaryGreen.main",
              mr: 1,
              fontSize: 16,
              display: { xs: "none", sm: "block" },
            }}
          >
            {iconTitle}
          </Typography>
        )}
      </Box>

      <Typography variant="titleSteps" sx={{ fontSize: { xs: 20, sm: 24 } }}>
        {title}
      </Typography>

      {(id || name) && (
        <Typography
          sx={{
            fontSize: { xs: 16, sm: 24 },
            ml: 1,
          }}
        >
          {id ? id.length > 1 ? "IDs " + id.map((i) => " " + i) : "ID " +  id[0]   : name}
        </Typography>
      )}
    </Box>
  );
};

export default TitleHeadSess;
